import { SOURCE_LABEL, STAGE_AUTO_SOURCE, STAGE_NAMES, fmtMD } from "../../../../lib/giftingRules";
import type { GfStage, GfStageEvent, GfStageSource } from "../../../../types/gifting";
import { GfAutoTag } from "../../ui/GfAction";

/** 自動で進んだ段階のミニタグ用（手動以外）。v2: 「自動 · 倉庫 9/13」 */
const AUTO_TAG_LABEL: Partial<Record<GfStageSource, string>> = {
  form: "本人フォーム",
  oms: "倉庫",
  ig_api: "IG検知",
  system: "システム",
};

/** 進行状態タイムライン（0リスト化〜7 2次利用許諾の8段階）。日付・出所は段階履歴(events)から */
export function EntryTimeline({ stage, events }: { stage: GfStage; events: GfStageEvent[] | null }) {
  const steps = STAGE_NAMES.slice(0, 8);
  return (
    <div className="gf-tl">
      <span className="gf-panel-section-title gf-tl-title">進行状態</span>
      {steps.map((name, i) => {
        // 段階 i に到達した最後の履歴
        let ev: GfStageEvent | null = null;
        if (events) for (const x of events) if (x.to_stage === i && (!ev || x.id > ev.id)) ev = x;
        const reached = i <= stage;
        const done = i < stage;
        const auto = STAGE_AUTO_SOURCE[i as GfStage];
        let src = "";
        let srcAuto = false;
        if (reached) {
          if (ev) {
            src = SOURCE_LABEL[ev.source];
            srcAuto = ev.source !== "manual";
          }
        } else if (auto) {
          src = `自動：${auto}`;
          srcAuto = true;
        }
        return (
          <div className="gf-tl-step" key={i}>
            <span className="gf-tl-rail">
              <span className={`gf-tl-dot${done ? " is-done" : reached ? " is-current" : ""}`} />
              <span className={`gf-tl-line${done ? " is-done" : ""}${i === steps.length - 1 ? " is-last" : ""}`} />
            </span>
            <span className={`gf-tl-name${reached ? "" : " is-future"}${i === stage ? " is-current" : ""}`}>
              {name}
              {reached && ev && AUTO_TAG_LABEL[ev.source] && (
                <GfAutoTag>
                  自動 · {AUTO_TAG_LABEL[ev.source]} {fmtMD(ev.created_at)}
                </GfAutoTag>
              )}
            </span>
            <span className="gf-tl-meta">
              <span className="gf-mono gf-tl-date">{reached && ev ? fmtMD(ev.created_at) : ""}</span>
              <span className={`gf-tl-src${srcAuto ? " is-auto" : ""}`}>{reached && ev && AUTO_TAG_LABEL[ev.source] ? "" : src}</span>
            </span>
          </div>
        );
      })}
    </div>
  );
}
